// inv/src/components/lists/RenderContent.jsx
const RenderContent = ({ contentObject }) => {
  if (!contentObject || typeof contentObject !== 'object' || Object.keys(contentObject).length === 0) {
    return (
      <>
        <div className="animate-pulse bg-gray-300 h-8 w-2/3 rounded mb-4"></div>
        <div className="animate-pulse bg-gray-200 h-4 w-full rounded mb-2"></div>
        <div className="animate-pulse bg-gray-200 h-4 w-5/6 rounded mb-2"></div>
        <div className="animate-pulse bg-gray-200 h-4 w-4/6 rounded mb-4"></div>
      </>
    );
  }

  const sortedKeys = Object.keys(contentObject).sort();

  return (
    <>
      {sortedKeys.map((key, index) => {
        const value = contentObject[key];
        if (!value) return null;

        if (key.startsWith('h2')) {
          return <h2 key={index} className="mt-8 text-lg font-bold">{value}</h2>;
        } else if (key.startsWith('text')) {
          return <p key={index} className="text-base leading-relaxed my-6">{value}</p>;
        }

        return null;
      })}
    </>
  );
};

export default RenderContent;
